import { createSlice, current, Draft, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
	limit: JSON.parse(localStorage.getItem('pageLimit') as string) || 1000,
	data: null,
	routeList: null,
	pages: 0,
	count: null,
	filters: {
		routeStatusType: [],
		vSupervisor: [],
		supervisor: [],
	},
	total: {
		totalIncome: 0,
		totalPlaces: 0,
		totalPlannedWage: 0,
		totalReports: 0,
		totalVisits: 0,
		totalWorkload: 0,
	},
	vacantRoutesInputValues: {
		routeNo: null,
		merch: [],
		visitType: [],
		employeeStatus: null,
	},
	vacantCheckboxesList: [],
	isPending: true
};
export const vacantRoutesSlice = createSlice({
	name: 'vacantRoutesNoModal',
	initialState,
	reducers: {
		reducerGetVacantRoutes: (state: Draft<any>, action: PayloadAction<any>) => {
			state.count = action.payload.data.count;
			state.pages = action.payload.data.pages;
			state.total.totalWorkload = action.payload.data.totalWorkload;
			state.total.totalIncome = action.payload.data.totalIncome;
			state.total.totalPlannedWage = action.payload.data.totalPlannedWage;
			state.total.totalReports = action.payload.data.totalReports;
			state.total.totalPlaces = action.payload.data.totalPlaces;
			state.total.totalVisits = action.payload.data.totalVisits;

			function findCommonObjects() {
				const data = action.payload.data?.data;
				if(state.routeList.data && data) {
					const routeList = current(state.routeList.data);
					const commonObjects = data.filter((obj1: any) => {
						return  routeList.some((obj2: any) => obj2.routeNo === obj1.routeNo && obj2.project.id === obj1.project.id);
					});
				return commonObjects;
				} else {
					return []
				}
		}
			state.data = state.routeList && findCommonObjects();
		},
		reducerSetLimit: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.limit = action.payload
		},
		reducerGetRouteList: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.routeList = action.payload
		},
		reducerGetVacantRoutesFilters: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.filters.merch = action.payload.data?.merch?.map((option: any) => {
				return { value: option.id, label: option.name };
			});
			state.filters.routeStatusType = Object.entries(action.payload.data?.routeStatusType || {}).map(([key, value]) => ({ value: key, label: value }));

			state.filters.vSupervisor = action.payload.data?.vsupervisor?.map(
				(option: any) => ({
					value: option.id,
					label: option.name,
				})
			);
			state.filters.supervisor = action.payload.data?.supervisor?.map(
				(option: any) => ({
					value: option.id,
					label: option.name,
				})
			);

			state.filters.project = action.payload.data?.project?.map(
				(option: any) => ({
					value: option.id,
					label: option.name,
				})
			);
		},
		reducerVacantRoutesInputValues: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.vacantRoutesInputValues = {...state.vacantRoutesInputValues,...action.payload};
		},
		reducerSetVacantCheckboxes: (state: Draft<any>, action: PayloadAction<any>) => {
			state.vacantCheckboxesNoModule = action.payload;
		},
		reducerSetVacantListCheckboxes: (state: Draft<any>, action: PayloadAction<any>) => {
			if (state.vacantCheckboxesList.find((o: any) => o.routeNo === action.payload.routeNo)) {
				state.vacantCheckboxesList = state.vacantCheckboxesList.filter((o: any) => o.routeNo !== action.payload.routeNo)
			} else {
				state.vacantCheckboxesList = [...state.vacantCheckboxesList, action.payload];
			}
		},
		reducerSetVacantListCheckboxesClear: (state: Draft<any>) => {
			state.vacantCheckboxesList = [];
		},
		reducerClearInputValuesNoModal: (state: Draft<any>) => {
			state.vacantRoutesInputValues = {
				routeNo: null,
				merch: [],
				visitType: [],
				employeeStatus: null,
			};
		},
	},
});

export const {
	reducerGetVacantRoutes,
	reducerGetRouteList,
	reducerGetVacantRoutesFilters,
	reducerVacantRoutesInputValues,
	reducerSetVacantCheckboxes,
	reducerSetVacantListCheckboxes,
	reducerSetVacantListCheckboxesClear,
	reducerClearInputValuesNoModal,
	reducerSetLimit,
} = vacantRoutesSlice.actions;

export default vacantRoutesSlice.reducer;
